import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {NgClass, NgTemplateOutlet} from '@angular/common';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap/tooltip';
import {RouterLink} from '@angular/router';

@Component({
    selector: 'app-icon-button',
    templateUrl: './icon-button.component.html',
    styleUrls: ['./icon-button.component.scss'],
    imports: [FaIconComponent, NgClass, NgbTooltip, NgTemplateOutlet, RouterLink]
})
export class IconButtonComponent implements OnInit {

  @Input() ariaLabel: string;
  @Input() tooltip: string;

  @Input() icon: IconProp;
  @Input() text: string;
  @Input() element: 'button' | 'link' = 'button';
  @Input() buttonType: string = 'button';
  @Input() routerLink: any[] | string | null | undefined;
  @Input() state: {[p: string]: any};

  @Input('alignment') _alignment: 'vertical' | 'horizontal' | null;

  /**
   * Button clicked.
   *
   * When this component is used with element=link and a provided routerLink,
   * then the link will trigger the router like normal and this output won't fire.
   */
  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  public get vertical(): boolean {
    return this._alignment === 'vertical';
  }

}
